import BaseViewController from "./base-view-controller";
import { formatPhone } from "../utils/prepare-submit";
import { getFlow } from "../api/flow";

class AccountProfileEditViewController extends BaseViewController {
  prepareSubmit(values) {
    values = formatPhone(values, "phone_faxes.0.");
    values = formatPhone(values, "phone_faxes.1.");
    return values;
  }

  handleButtonClick(name, text, action) {
    if (name === "saveButton") {
      // eslint-disable-next-line new-cap
      this.appData.setFlowStatusLoading();
      getFlow({
        url: action.value,
        formState: this.prepareSubmit(this.appData.values)
      }).then(() => {
        this.appData.prevScreen();
        this.resetActionField();
      });
    }
  }

  handleBackButtonClick() {
    super.handleBackButtonClick();
    this.resetActionField();
  }

  // TODO: Field reference should be removed in Q1
  resetActionField() {
    this.appData.resetActionField("member_id");
  }
}

export default AccountProfileEditViewController;
